/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FinancialChannelResponse } from './FinancialChannelResponse';
import {
    FinancialChannelResponseFromJSON,
    FinancialChannelResponseFromJSONTyped,
    FinancialChannelResponseToJSON,
    FinancialChannelResponseToJSONTyped,
} from './FinancialChannelResponse';
import type { FinancialGroupPermissionResponse } from './FinancialGroupPermissionResponse';
import {
    FinancialGroupPermissionResponseFromJSON,
    FinancialGroupPermissionResponseFromJSONTyped,
    FinancialGroupPermissionResponseToJSON,
    FinancialGroupPermissionResponseToJSONTyped,
} from './FinancialGroupPermissionResponse';

/**
 * Response for get financial group by id
 * @export
 * @interface FinancialGroupResponse
 */
export interface FinancialGroupResponse {
    /**
     * Unique identifier of the financial group
     * @type {number}
     * @memberof FinancialGroupResponse
     */
    id?: number;
    /**
     * The financial group code
     * @type {string}
     * @memberof FinancialGroupResponse
     */
    code?: string;
    /**
     * The financial group title
     * @type {string}
     * @memberof FinancialGroupResponse
     */
    title?: string;
    /**
     * Indicate if the appointment type is active
     * @type {boolean}
     * @memberof FinancialGroupResponse
     */
    active?: boolean;
    /**
     * list of dayModel data
     * @type {Array<FinancialChannelResponse>}
     * @memberof FinancialGroupResponse
     */
    financialChannels?: Array<FinancialChannelResponse>;
    /**
     * 
     * @type {Array<FinancialGroupPermissionResponse>}
     * @memberof FinancialGroupResponse
     */
    permissions?: Array<FinancialGroupPermissionResponse>;
    /**
     * 
     * @type {string}
     * @memberof FinancialGroupResponse
     */
    owner?: string;
}

/**
 * Check if a given object implements the FinancialGroupResponse interface.
 */
export function instanceOfFinancialGroupResponse(value: object): value is FinancialGroupResponse {
    return true;
}

export function FinancialGroupResponseFromJSON(json: any): FinancialGroupResponse {
    return FinancialGroupResponseFromJSONTyped(json, false);
}

export function FinancialGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'title': json['title'] == null ? undefined : json['title'],
        'active': json['active'] == null ? undefined : json['active'],
        'financialChannels': json['financialChannels'] == null ? undefined : ((json['financialChannels'] as Array<any>).map(FinancialChannelResponseFromJSON)),
        'permissions': json['permissions'] == null ? undefined : ((json['permissions'] as Array<any>).map(FinancialGroupPermissionResponseFromJSON)),
        'owner': json['owner'] == null ? undefined : json['owner'],
    };
}

export function FinancialGroupResponseToJSON(json: any): FinancialGroupResponse {
    return FinancialGroupResponseToJSONTyped(json, false);
}

export function FinancialGroupResponseToJSONTyped(value?: FinancialGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'title': value['title'],
        'active': value['active'],
        'financialChannels': value['financialChannels'] == null ? undefined : ((value['financialChannels'] as Array<any>).map(FinancialChannelResponseToJSON)),
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(FinancialGroupPermissionResponseToJSON)),
        'owner': value['owner'],
    };
}

